/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, HostListener, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { environment, ModulesEnum } from '../../../environments/environment';

@Component({
    selector: 'app-base',
    template: '<div></div>'
})
export abstract class BaseComponent implements OnDestroy {
    protected destroyed$: Subject<boolean> = new Subject();

    @HostListener('window:beforeunload', ['$event'])
    public ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    /**
     * Get app environment.
     */
    get environment(): any {
        return environment;
    }

    /**
     * Get the Modules ENUM, so we can use it in the view.
     */
    get modulesEnum(): any {
        return ModulesEnum;
    }
}
